import React, { useRef, useEffect } from 'react'

import { useSearchParams } from 'react-router-dom'

import { useParams } from 'react-router'

import { useTranslation } from 'react-i18next'

import { IPlanMenuControlOrdersRequest } from 'core/api/dto/PlanMenuControlDto'
import { AppScrollWrapperNew } from 'widgets/AppScrollWrapper/AppScrollWrapper'
import { FrozeCloseItem } from './FrozeCloseItem'
import { useGetPlanCloseDimensionByOrderLineQuery } from 'core/api/PlanMenuCloseDimensionApi'

interface IFrozeListProps {
  pageParams?: IPlanMenuControlOrdersRequest | null
  withTaskAddButton?: boolean
}

export const FrozeCloseList = ({
  withTaskAddButton,
}: IFrozeListProps) => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const { dishId } = useParams()
  const currentOrderId = searchParams.get('dish')
  const scrollRef = useRef<HTMLDivElement>(null)

  const { data: dimensionList } = useGetPlanCloseDimensionByOrderLineQuery({
    orderLineId: Number(currentOrderId || 0),
  })

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0
    }
  }, [currentOrderId])

  return (
    <div className="froze-list-wrap">
      <AppScrollWrapperNew theme="dropdown" ref={scrollRef}>
        <div></div>
        {!!dimensionList && (!!currentOrderId || dishId) && (
          <React.Fragment>
            {[...dimensionList]
              .reverse()
              .map((item, index) => (
                <div
                  key={`${item.id}-fr-${index}`}
                  style={{ marginRight: 10, marginTop: 10 }}
                >
                  <FrozeCloseItem
                    dimensionItem={item}
                    index={index + 1}
                    withTaskAddButton={withTaskAddButton}
                  />
                </div>
              ))
              .reverse()}
            {!dimensionList?.length && (
              <div>{t('Замеров по данному заказу нет')}</div>
            )}
          </React.Fragment>
        )}
      </AppScrollWrapperNew>
    </div>
  )
}